module.exports = __webpack_public_path__ + "img/kr-product-card3-item4-step4.e4ab9cb.png";